import { Component } from "react"

/* Router */
import { BrowserRouter, Routes, Route } from "react-router-dom"

/* Widgets */
import Stand from "./widgets/Stand"


/* Entry point */
class App extends Component {

    render = () => (
        <BrowserRouter>
            <Routes>
                <Route path="/:key" element={<Stand />} />
                <Route path="*" element={<Stand />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App
